import React from 'react';
import { modelClass } from '/imports/api/sets';
import { ModelFormPage } from '/imports/ui/ModelFormPage';
import { NumberInput } from '/imports/ui/NumberInput';

export const CardSetPage = () => (
  <ModelFormPage
    modelClass={modelClass as any}
    permission={(user) => !!user?.isSuperUser}
    formSpec={() => [
      [{ field: 'name', label: 'Name' }],
      [
        {
          field: 'gbBuyMargin', label: 'GB Buy Margin (%)', optional: true,
          input: { type: NumberInput },
          tip: 'Applied to every card in the set with no per-card margin. manBuyPrice = gbBuyPrice × (1 + margin/100).',
        },
        {
          field: 'gbSellMargin', label: 'GB Sell Margin (%)', optional: true,
          input: { type: NumberInput },
          tip: 'Applied to every card in the set with no per-card margin. manSellPrice = gbSellPrice × (1 + margin/100).',
        },
      ],
    ]}
  />
);
